import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { NutraceuticalIngredientMaster } from '../models/master/nutraceutical-ingredient-master';

@Injectable({ providedIn: 'root' })
export class NutraceuticalIngredientMasterService {
  private readonly baseUrl = `${environment.apiUrl}/NutraceuticalIngredientMaster`;

  constructor(private http: HttpClient) {}

  async getList(activeOnly = false): Promise<NutraceuticalIngredientMaster[]> {
    const res: any = await this.http
      .get(`${this.baseUrl}/GetNutraceuticalIngredientList`, { params: { activeOnly } })
      .toPromise();
    return this.mapRows(res);
  }

  async search(search: string, limit = 50, activeOnly = true): Promise<NutraceuticalIngredientMaster[]> {
    const term = (search || '').trim();
    if (term.length < 2) {
      return [];
    }

    const res: any = await this.http
      .get(`${this.baseUrl}/SearchNutraceuticalIngredients`, {
        params: { search: term, limit, activeOnly },
      })
      .toPromise();
    return this.mapRows(res);
  }

  async getById(id: number, activeOnly = true): Promise<NutraceuticalIngredientMaster | null> {
    const res: any = await this.http
      .get(`${this.baseUrl}/GetNutraceuticalIngredientById/${id}`, { params: { activeOnly } })
      .toPromise();
    const row = res?.response ?? res?.Response ?? res;
    if (!row || typeof row !== 'object') {
      return null;
    }
    return this.mapRow(row);
  }

  async addEdit(dto: {
    id: number;
    ingredientName: string;
    category?: string | null;
    uniqueIngredients?: string | null;
    minDailyUsage?: string | null;
    maxDailyUsage?: string | null;
    uom?: string | null;
    unitDosageMasterId?: number | null;
    isActive: boolean;
  }): Promise<any> {
    return this.http.post(`${this.baseUrl}/AddEditNutraceuticalIngredient`, dto).toPromise();
  }

  async delete(id: string | number): Promise<any> {
    return this.http.get(`${this.baseUrl}/DeleteNutraceuticalIngredientById/${id}`).toPromise();
  }

  private mapRows(res: any): NutraceuticalIngredientMaster[] {
    const rows = res?.response ?? res?.Response ?? res;
    return (Array.isArray(rows) ? rows : []).map((row) => this.mapRow(row));
  }

  private mapRow(row: any): NutraceuticalIngredientMaster {
    return {
      id: Number(row?.id ?? row?.Id ?? 0),
      ingredientName: row?.ingredientName ?? row?.IngredientName ?? '',
      category: row?.category ?? row?.Category ?? null,
      uniqueIngredients: row?.uniqueIngredients ?? row?.UniqueIngredients ?? null,
      minDailyUsage: row?.minDailyUsage ?? row?.MinDailyUsage ?? null,
      maxDailyUsage: row?.maxDailyUsage ?? row?.MaxDailyUsage ?? null,
      uom: row?.uom ?? row?.Uom ?? null,
      unitDosageMasterId: row?.unitDosageMasterId ?? row?.UnitDosageMasterId ?? null,
      isActive: row?.isActive !== false && row?.IsActive !== false,
      reeworkLegacyId: row?.reeworkLegacyId ?? row?.ReeworkLegacyId ?? null,
      legacySource: row?.legacySource ?? row?.LegacySource ?? null,
    };
  }
}
